import ApiService from "../../common/api.service";
import Vue from "vue";

const state = {
  all: [],
  cache: {}
};

// getters
const getters = {
  getCourseDefinition: state => id => {
    return state.all.find(definition => definition.id === id);
  },
  getAll: state => {
    return state.all.filter(
      courseDefinition => courseDefinition.deleted === false
    );
  },
  getAllWithDeleted: state => {
    return state.all;
  }
};

// actions
const actions = {
  addCourseDefinition(context, courseDefinition) {
    return new Promise((resolve, reject) => {
      ApiService.post("/course/definition", courseDefinition)
        .then(response => {
          context.commit("ADD", response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateCourseDefinition(context, courseDefinition) {
    return new Promise((resolve, reject) => {
      ApiService.put(
        "/course/definition/" + courseDefinition.id,
        courseDefinition
      )
        .then(response => {
          context.commit("UPDATE", response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteCourseDefinition(context, courseDefinition) {
    return new Promise((resolve, reject) => {
      ApiService.delete("/course/definition/" + courseDefinition.id)
        .then(() => {
          context.commit("DEL", courseDefinition);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadCourseDefinitions(context) {
    ApiService.get("/course/definition").then(response => {
      context.commit("SET", response.data);
    });
  }
};

// mutations
const mutations = {
  ADD(state, item) {
    state.all.push(item);
    state.cache[item.id] = state.all.length - 1;
  },
  SET(state, items) {
    state.all = items;
    createCache(items);
  },
  UPDATE(state, item) {
    const index = state.cache[item.id];
    Vue.set(state.all, index, item);
  },
  DEL(state, item) {
    state.all.splice(state.cache[item.id], 1);
  }
};

function createCache(items) {
  for (let i = 0; i < items.length; i++) {
    state.cache[items[i].id] = i;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
